module.exports = __webpack_public_path__ + "img/cosmo_base_woman.300f3418.png";